import { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { ptBR } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/**
 * DatePickerBR — picker de data localizado em pt-BR.
 * Recebe e devolve string ISO (yyyy-mm-dd) compatível com o backend,
 * exibe ao usuário no formato dd/MM/yyyy.
 */
export default function DatePickerBR({ value, onChange, testid, placeholder = "dd/mm/aaaa" }) {
  const [open, setOpen] = useState(false);

  const parsed = value ? parse(value, "yyyy-MM-dd", new Date()) : null;
  const display = parsed && isValid(parsed) ? format(parsed, "dd/MM/yyyy", { locale: ptBR }) : "";

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="input-mil flex items-center justify-between gap-2 text-left"
          data-testid={testid}
        >
          <span className={display ? "" : "text-[var(--text-muted)]"}>{display || placeholder}</span>
          <CalendarIcon size={14} className="text-[var(--text-muted)]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={parsed && isValid(parsed) ? parsed : undefined}
          onSelect={(d) => {
            if (d) {
              onChange(format(d, "yyyy-MM-dd"));
              setOpen(false);
            }
          }}
          locale={ptBR}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
